import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getAuthModule, useAuthStatus } from 'features/auth';
import { editMyProfile } from './myProfileApi';
export function useEditMyProfile() {
    const status = useAuthStatus();
    const queryClient = useQueryClient();
    const user = status.kind === 'authenticated' ? status.user : null;
    return useMutation({
        mutationFn: async ({ profile, body }) => {
            if (!user)
                throw new Error('Not authenticated');
            await editMyProfile(profile, user, body);
            // Re-run the auth pipeline so `subject.principal.user[0].name` flows back into AuthUser.
            await getAuthModule().refreshStatus();
            // Invalidate the cached myProfile so any consumer (settings, future re-render of setup)
            // pulls the fresh `whatsAppE164` and edit action.
            await queryClient.invalidateQueries({ queryKey: ['myProfile'] });
        },
    });
}
